import { ABORT_ERROR_NAME } from '@federa/const/http-error-codes';
import { NETWORK_ERROR_CODES } from '@federa/const/network-error-codes';
import { TRANSIENT_NETWORK_ERROR_MESSAGE_TOKENS } from '@federa/const/retry-error-tokens';
import type { HttpRetryConfig } from '@federa/types/http-api';

/** Membership view over the errno SSOT. The literal list used to be spelled here; it moved to
 *  `const/network-error-codes.ts` when the PostToolUseFailure non-filing gate became a second reader of the same tokens. */
const RETRYABLE_ERRNO = new Set<string>(Object.values(NETWORK_ERROR_CODES));

// HTTP retry-classifier message tokens from the canonical TRANSIENT_NETWORK_ERROR_MESSAGE_TOKENS SSOT shared with KV/R2. The HTTP-status path is handled separately via `isRetryableStatus`, so 5xx number/message tokens are not included here.
const NETWORK_ERROR_MESSAGE_PATTERNS: readonly string[] = TRANSIENT_NETWORK_ERROR_MESSAGE_TOKENS;

interface RetryableError {
	name?: string;
	code?: string | number;
	message?: string;
}

export function isRetryableError(error: RetryableError, config: HttpRetryConfig): boolean {
	if (!config.retryOnNetworkError) {
		return false;
	}

	const { name = '', code } = error;
	if (name === ABORT_ERROR_NAME || name === 'TypeError') {
		return true;
	}

	if (code && RETRYABLE_ERRNO.has(String(code).toUpperCase())) {
		return true;
	}

	const message = typeof error.message === 'string' ? error.message.toLowerCase() : '';
	if (message && NETWORK_ERROR_MESSAGE_PATTERNS.some((pattern) => message.includes(pattern))) {
		return true;
	}

	return false;
}
